import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import { useLoaderData } from 'react-router-dom'

import { ArcadeIcon, CheckFillIcon, FailedFillIcon } from '@arcade/web/icons/react'
import { Toast } from '@cash-design-system/react'
import { useJourneyContext } from '@cash-web/shared-journey-data-access-context'

export type ShareTextToastResult = 'copy-link' | 'copy-text' | 'failure'

export type ShareTextToastData = {
  result: ShareTextToastResult
}

const getToastContent = (result: ShareTextToastResult, t: TFunction) => {
  switch (result) {
    case 'copy-link':
      return { headline: t('Copied link', { context: 'success toast' }), icon: CheckFillIcon as ArcadeIcon }
    case 'copy-text':
      return { headline: t('Copied', { context: 'success toast' }), icon: CheckFillIcon as ArcadeIcon }
    case 'failure':
      return { headline: t('Unable to copy text', { context: 'error toast' }), icon: FailedFillIcon as ArcadeIcon }
  }
}

export const ShareTextToast = () => {
  const { t } = useTranslation()
  const journey = useJourneyContext()
  const { result } = useLoaderData() as ShareTextToastData
  const { headline, icon } = getToastContent(result, t)

  return (
    <Toast
      headline={headline}
      icon={icon}
      dismissTimeout={3000}
      data-testid="share-text-toast"
      onClose={() => journey.complete()}
    />
  )
}
